import { render } from "./GeoItem.vue?vue&type=template&id=0ba2454f&scoped=true&ts=true"
import script from "./GeoItem.vue?vue&type=script&lang=ts"
export * from "./GeoItem.vue?vue&type=script&lang=ts"

import "./GeoItem.vue?vue&type=style&index=0&id=0ba2454f&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba2454f"]])

export default __exports__